/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, June 17th 2022, 10:16:10 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { ErrorFallback } from "./ErrorFallback";

interface UIErrorState {
  error: any;
  errorInfo: any;
}

export class UIErrorBoundary extends React.Component<{}, UIErrorState> {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null } as UIErrorState;
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      if (process.env.NODE_ENV === "production") return <ErrorFallback />;

      return (
        <details style={{ whiteSpace: "pre-wrap" }}>
          {this.state.error && this.state.error.toString()}
          <br />
          {this.state.errorInfo.componentStack}
        </details>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
